const credit = {
    credit: 'Credits',
    credit_balance: 'Credit balance',
    add: 'Add Credit',
    empty: 'Credit history will show when they are available',
    modal_title: 'Select payment method',
    credit_details:'Credit detail',
}

export default credit;